const c = (a, e) => {
  if (e) {
    let o = a;
    Object.entries(e).forEach(([i, n]) => {
      o = o.replace(`$${i}`, n);
    }), window.location.hash = o;
  } else
    window.location.hash = a;
}, h = () => {
  window.location.hash = "";
};
export {
  c as addTrackingHash,
  h as removeTrackingHash
};
